import { authStore, brandStore } from '@/stores';
import {
  LOCAL_DEV_BYPASS_BRAND,
  LOCAL_DEV_BYPASS_USER,
  shouldEnableLocalDevBypass,
} from './localDevBypassCore';

export { LOCAL_DEV_BYPASS_QUERY } from './localDevBypassCore';

export function applyLocalDevBypass() {
  if (
    typeof window === 'undefined' ||
    !shouldEnableLocalDevBypass(window.location)
  ) {
    return false;
  }

  authStore.enableLocalDevBypass(LOCAL_DEV_BYPASS_USER);

  brandStore.brands = [LOCAL_DEV_BYPASS_BRAND];
  brandStore.activeBrandId = LOCAL_DEV_BYPASS_BRAND.id;
  brandStore.loading = false;
  brandStore.creating = false;
  brandStore.waitlistTotalsLoading = false;
  brandStore.initialized = true;
  brandStore.error = '';
  brandStore.waitlistTotals = {
    [LOCAL_DEV_BYPASS_BRAND.id]: 0,
  };

  window.localStorage.setItem('active-brand-id', LOCAL_DEV_BYPASS_BRAND.id);
  return true;
}
